import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/core/dialog.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { EventCalendarDataService } from '../../../event-calendar.data.service';
import { calendarCategoriesColorOptions } from '../data';
import { finalize } from 'rxjs/operators';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { ColorDialogComponent } from '../color-dialog/color-dialog.component';

@Component({
    selector: 'app-add-edit-calendar-category-dialog',
    templateUrl: './add-edit-calendar-category-dialog.component.html',
    styleUrls: ['./add-edit-calendar-category-dialog.component.scss'],
    standalone: false
})
export class AddEditCalendarCategoryDialogComponent implements OnInit {
  public colorOptions: string[] = calendarCategoriesColorOptions;
  selectedColor: string = '';
  itemData: any = '';
  requestInProgress = false;
  colorTouched = false;
  calendarId: any = '';
  public componentForm!: UntypedFormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddEditCalendarCategoryDialogComponent>,
    private dialogService: DialogService,
    public toasterService: ToasterService,
    public eventCalendarDataService: EventCalendarDataService,
    public dialog: NgDialogAnimationService
  ) {
    this.itemData = this.data.itemData;
    this.selectedColor = this.itemData?.color || this.colorOptions[0];
    this.colorTouched = !!(this.itemData?.color && this.itemData.color !== this.colorOptions[0]);
    this.calendarId = this.data.calendarId;
    console.log("this.calendarId===",this.calendarId  );
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.componentForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.data?.itemData?.title || '', [
        Validators.required,
      ]),
      color: new UntypedFormControl(this.selectedColor),
    });
  }

  getFormData() {
    const formValue = this.componentForm.value;
    const payload = {
      title: formValue.name,
      color: this.selectedColor,
      calendar_id: this.calendarId,
    };
    return payload;
  }

  save() {
    this.touchFormControls();
    if (this.componentForm.invalid) {
      return;
    }
    this.requestInProgress = true;
    const payload = this.getFormData();
    const apiCall =
      this.itemData && this.itemData.id
        ? this.eventCalendarDataService.updateCalendarCategory(
          this.itemData.id,
          payload
        )
        : this.eventCalendarDataService.createCalendarCategory(payload);

    apiCall.pipe(finalize(() => (this.requestInProgress = false))).subscribe({
      next: (response) => {
        this.toasterService.showSuccessMessage(response?.message);
        this.close(true);
      },
    });

  }

  openColorDialog() {
    const dialogRef = this.dialog.open(ColorDialogComponent, {
      width: '500px',
      maxWidth: '500px',
      maxHeight: '80vh',
      panelClass: 'color-dialog-container',
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (!this.colorOptions.includes(result)) {
          calendarCategoriesColorOptions.splice(1, 0, result);
          this.colorOptions = [...calendarCategoriesColorOptions];
        }
        this.selectColor(result);
      }
    });
  }

  selectColor(color: string) {
    this.selectedColor = color;
    this.colorTouched = true;
    this.componentForm.get('color')?.setValue(color);
  }

  close = (data: any = null) => {
    this.dialogRef.close(data);
  };

  touchFormControls() {
    Object.keys(this.componentForm.controls).forEach((key) => {
      this.componentForm.get(key)?.markAsTouched();
    });
  }
}
